import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { apiRequest } from "../../lib/request"

/**
 * PATCH /api/v1/media/asset/:mediaId/save-edited
 * Optional query: ?postMediaId= (contentTopicPostMedias row id from review panel).
 * Omit postMediaId when creating a new post before the CTP media row exists.
 * Multipart field: file
 */
export const replaceMedia = createAsyncThunk(
    "mediaReplace/replaceMedia",
    async ({ mediaId, contentTopicPostMediaId, file }, { rejectWithValue }) => {
        try {
            if (mediaId == null || mediaId === "") {
                throw new Error("Media ID is required")
            }
            if (!file) throw new Error("File is required")

            const formData = new FormData()
            formData.append("file", file)

            let url = `media/asset/${encodeURIComponent(mediaId)}/save-edited`
            if (contentTopicPostMediaId != null && String(contentTopicPostMediaId).trim() !== "") {
                url += `?postMediaId=${encodeURIComponent(contentTopicPostMediaId)}`
            }

            const response = await apiRequest(url, {
                method: "PATCH",
                body: formData,
            })

            return response
        } catch (error) {
            console.error("Media replace error:", error)
            return rejectWithValue(error.message || "Failed to replace media")
        }
    }
)

const mediaReplaceSlice = createSlice({
    name: "mediaReplace",
    initialState: {
        status: "idle",
        error: null,
        replacedMedia: null,
    },
    reducers: {
        resetReplaceState: (state) => {
            state.status = "idle"
            state.error = null
            state.replacedMedia = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(replaceMedia.pending, (state) => {
                state.status = "loading"
                state.error = null
            })
            .addCase(replaceMedia.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.replacedMedia = action.payload
            })
            .addCase(replaceMedia.rejected, (state, action) => {
                state.status = "failed"
                state.error = action.payload
            })
    },
})

export const { resetReplaceState } = mediaReplaceSlice.actions
export default mediaReplaceSlice.reducer
